// formatting for use in concept reports
// - used for yml files
// - converting yml style \t \n to html tags for use in editor

export const processReportFile = (parsedFile) => {
  let processedDoc = {
    title: parsedFile.titel,
    report: ""
  };
  let stitchedReport = [];
  if (Object.keys(parsedFile).indexOf("intro") > 0) {
    stitchedReport.push(addSpanToVars(sanatizeText(parsedFile.intro)));
  };
  if (Object.keys(parsedFile).indexOf("inhoud") > 0) {
    // stitchedReport.push("</p><p>");
    stitchedReport.push(addSpanToVars(sanatizeText(parsedFile.inhoud)));
  };
  if (Object.keys(parsedFile).indexOf("vragen") > 0) {
    // stitchedReport.push("</p><p>");
    stitchedReport.push(addSpanToVars(prepareQuestions(parsedFile.vragen)));
  };
  if (Object.keys(parsedFile).indexOf("outro") > 0) {
    // stitchedReport.push("</p><p>");
    stitchedReport.push(addSpanToVars(sanatizeText(parsedFile.outro)));
  };
  // stitchedReport.push("</p>");
  processedDoc.report = stitchedReport.join('<br />');
  
  return processedDoc;
};

export const sanatizeText = (old_text) => {
  let new_text = "<p>" + old_text.replace(/\n/g, "<br>") + "</p>"; 
  return new_text;
};

export const addSpanToVars = (old_text) => {
  let new_text;
  let span_text = '<span class="varspan" style="text-decoration-style: wavy; text-decoration: underline; text-decoration-color: green; text-decoration-thickness: 3px;">';
  new_text = old_text.replace(/x{3}(\S+)x{3}/ig, span_text+'$1</span>');
  new_text = new_text.replace(/x{3,}/ig,  span_text+'_antwoord_</span>');
  return new_text;
};

export const removeSpanFromVars = (old_text) => {
  // remove style from all spans (to prevent styling being visible in pdf export)
  let new_text = old_text.replace(/<span[^>]*>(\w+|_)<\/span>/ig, "$1");
  return new_text;
}

export const prepareQuestions = (questions) => {
  let newQuestionsContent = [];
    questions.forEach(question =>
      newQuestionsContent.push("<p>V: " + question + "<br />A:&nbsp;</p><br />")
    );
    return newQuestionsContent.join('');
};